
// Getting sub project
export const GET_SUB_PROJECT_START = "MAP:GET_SUB_PROJECT_START";
export const GET_SUB_PROJECT_SUCCESS = "MAP:GET_SUB_PROJECT_SUCCESS";
export const GET_SUB_PROJECT_FAILURE = "MAP:GET_SUB_PROJECT_FAILURE";
export const CLEAR_SUB_PROJECT = "MAP:CLEAR_SUB_PROJECT";

// Getting sub project
export const GET_SUB_PROJECTS_START = "MAP:GET_SUB_PROJECTS_START";
export const GET_SUB_PROJECTS_SUCCESS = "MAP:GET_SUB_PROJECTS_SUCCESS";
export const GET_SUB_PROJECTS_FAILURE = "MAP:GET_SUB_PROJECTS_FAILURE";
export const CLEAR_SUB_PROJECTS = "MAP:CLEAR_SUB_PROJECTS";

export const GET_SUB_PROJECT_STATISTICS_START = "MAP:GET_SUB_PROJECT_STATISTICS_START";
export const GET_SUB_PROJECT_STATISTICS_SUCCESS = "MAP:GET_SUB_PROJECT_STATISTICS_SUCCESS";
export const GET_SUB_PROJECT_STATISTICS_FAILURE = "MAP:GET_SUB_PROJECT_STATISTICS_FAILURE";
export const CLEAR_SUB_PROJECTS_STATISTICS = "MAP:CLEAR_SUB_PROJECTS_STATISTICS";

// getting projects overview per regions
export const GET_SUB_PROJECTS_OVERVIEW_START = "MAP:GET_SUB_PROJECTS_OVERVIEW_START";
export const GET_SUB_PROJECTS_OVERVIEW_SUCCESS = "MAP:GET_SUB_PROJECTS_OVERVIEW_SUCCESS";
export const GET_SUB_PROJECTS_OVERVIEW_FAILURE = "MAP:GET_SUB_PROJECTS_OVERVIEW_FAILURE";
export const CLEAR_SUB_PROJECTS_OVERVIEW = "MAP:CLEAR_SUB_PROJECTS_OVERVIEW";

export const SHOW_NATIONAL_SUB_PROJECTS_OVERVIEW = 'SIDE_NAV_MENU:SHOW_NATIONAL_SUB_PROJECTS_OVERVIEW';
export const SHOW_SUB_PROJECTS_OVERVIEW = 'SIDE_NAV_MENU:SHOW_SUB_PROJECTS_OVERVIEW';
export const SHOW_SUB_PROJECT_MAP_LOADER = 'SHOW_SUB_PROJECT_MAP_LOADER';
export const SHOW_REGIONAL_SUB_PROJECTS_OVERVIEW = 'SHOW_REGIONAL_SUB_PROJECTS_OVERVIEW';
export const SHOW_DISTRICTS_SUB_PROJECTS_OVERVIEW= 'SHOW_DISTRICTS_SUB_PROJECTS_OVERVIEW';

export const GET_SUB_PROJECTS_REGIONS_OVERVIEW_START = "GET_SUB_PROJECTS_REGIONS_OVERVIEW_START";
export const GET_SUB_PROJECTS_REGIONS_OVERVIEW_SUCCESS = "GET_SUB_PROJECTS_REGIONS_OVERVIEW_SUCCESS";
export const GET_SUB_PROJECTS_REGIONS_OVERVIEW_FAILURE = "GET_SUB_PROJECTS_REGIONS_OVERVIEW_FAILURE";
export const CLEAR_SUB_PROJECTS_REGIONS_OVERVIEW = "CLEAR_SUB_PROJECTS_REGIONS_OVERVIEW";

export const GET_REGION_SUB_PROJECT_STATISTICS_START = "GET_REGION_SUB_PROJECT_STATISTICS_START";
export const GET_REGION_SUB_PROJECT_STATISTICS_SUCCESS = "GET_REGION_SUB_PROJECT_STATISTICS_SUCCESS";
export const GET_REGION_SUB_PROJECT_STATISTICS_FAILURE = "GET_REGION_SUB_PROJECT_STATISTICS_FAILURE";
export const CLEAR_REGION_SUB_PROJECTS_STATISTICS = "CLEAR_REGION_SUB_PROJECTS_STATISTICS";

export const GET_DISRTRICTS_SUB_PROJECTS_OVERVIEW_START = "GET_DISRTRICTS_SUB_PROJECTS_OVERVIEW_START";
export const GET_DISRTRICTS_SUB_PROJECTS_OVERVIEW_SUCCESS = "GET_DISRTRICTS_SUB_PROJECTS_OVERVIEW_SUCCESS";
export const GET_DISRTRICTS_SUB_PROJECTS_OVERVIEW_FAILURE = "GET_DISRTRICTS_SUB_PROJECTS_OVERVIEW_FAILURE";
export const CLEAR_DISRTRICTS_SUB_PROJECTS_OVERVIEW = "CLEAR_DISRTRICTS_SUB_PROJECTS_OVERVIEW";

export const GET_DISTRICTS_START = 'MAP:GET_DISTRICTS_START';
export const GET_DISTRICTS_SUCCESS = 'MAP:GET_DISTRICTS_SUCCESS';
export const GET_DISTRICTS_FAILURE = 'MAP:GET_DISTRICTS_FAILURE';

export const GET_SUB_PROJECT_TYPES_START = 'MAP:GET_SUB_PROJECT_TYPES_START';
export const GET_SUB_PROJECT_TYPES_SUCCESS = 'MAP:GET_SUB_PROJECT_TYPES_SUCCESS';
export const GET_SUB_PROJECT_TYPES_FAILURE = 'MAP:GET_SUB_PROJECT_TYPES_FAILURE';

export const GET_SUB_PROJECT_STATUS_START = 'MAP:GET_SUB_PROJECT_STATUS_START';
export const GET_SUB_PROJECT_STATUS_SUCCESS = 'MAP:GET_SUB_PROJECT_STATUS_SUCCESS';
export const GET_SUB_PROJECT_STATUS_FAILURE = 'MAP:GET_SUB_PROJECT_STATUS_FAILURE';

export const GET_CONTRACTORS_START = 'MAP:GET_CONTRACTORS_START';
export const GET_CONTRACTORS_SUCCESS = 'MAP:GET_CONTRACTORS_SUCCESS';
export const GET_CONTRACTORS_FAILURE = 'MAP:GET_CONTRACTORS_FAILURE';

export const GET_PROCURING_ENTITY_PACKAGE_START = 'MAP:GET_PROCURING_ENTITY_PACKAGE_START';
export const GET_PROCURING_ENTITY_PACKAGE_SUCCESS = 'MAP:GET_PROCURING_ENTITY_PACKAGE_SUCCESS';
export const GET_PROCURING_ENTITY_PACKAGE_FAILURE = 'MAP:GET_PROCURING_ENTITY_PACKAGE_FAILURE';

export const SET_SUB_PROJECT_TYPES_FILTER = 'MAP:SET_SUB_PROJECT_TYPES_FILTER';
export const SET_SUB_PROJECT_STATUS_FILTER = 'MAP:SET_SUB_PROJECT_STATUS_FILTER';
export const SET_SUB_PROJECT_COMPONENT_FILTER = 'MAP:SET_SUB_PROJECT_COMPONENT_FILTER';
export const SET_SUB_PROJECT_DISTRICT_FILTER = 'MAP:SET_SUB_PROJECT_DISTRICT_FILTER';
export const SET_SUB_PROJECT_CONTRACTOR_FILTER = 'MAP:SET_SUB_PROJECT_CONTRACTOR_FILTER';
export const SET_SUB_PROJECT_REGIONS_FILTER = "MAP:SET_SUB_PROJECT_REGIONS_FILTER";
export const SET_PROCURING_ENTITY_PACKAGE_FILTER = "MAP:SET_PROCURING_ENTITY_PACKAGE_FILTER";
export const GET_SUB_PROJECTS_BY_PROJECT_ID = "MAP:GET_SUB_PROJECTS_BY_PROJECT_ID";
